module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ebdW1"))).then(() => parcelRequire('ljYL6'));